import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .tooltip-div {
    display: inline-flex;
    height: 100%;
    width: 100%;
  }

  .tooltip-icon {
    color: ${colors.primary.dark};
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/optional-groups/style.js